import i18n from '@/i18n/translations';

// Internal order status
export enum InternalStatus {
  PENDING = 'pending',
  CREATED = 'created',
  DELIVERED = 'delivered',
  CANCELLED = 'cancelled',
  ERROR = 'error',
}

// ML shipment status
export enum ShipmentStatus {
  HANDLING = 'handling',
  SHIPPED = 'shipped',
  DELIVERED = 'delivered',
  CANCELLED = 'cancelled',
  NOT_DELIVERED = 'not_delivered',
}

export const getInternalStatusLabel = (status: string) => {
  switch (status) {
    case 'pending':
      return 'Pendiente';
    case 'created':
      return 'Creada';
    case 'delivered':
      return 'Entregada';
    case 'cancelled':
      return 'Cancelada';
    case 'error':
      return 'Error';
    default:
      return status;
  }
};

export const getInternalStatusBg = (status: string) => {
  switch (status) {
    case 'pending':
      return '#FFF9E6';
    case 'created':
      return '#D6F2DF';
    case 'delivered':
      return '#D1ECF1';
    case 'cancelled':
      return '#F6DDDC';
    case 'error':
      return '#F8D7DA';
    default:
      return '#F8F9FA';
  }
};

export const getInternalStatusColor = (status: string) => {
  switch (status) {
    case 'pending':
      return '#F39C12';
    case 'created':
      return '#27AE60';
    case 'delivered':
      return '#3498DB';
    case 'cancelled':
      return '#C0392B';
    case 'error':
      return '#E74C3C';
    default:
      return '#95A5A6';
  }
};

export const getShipmentStatusLabel = (status: string) => {
  switch (status) {
    case 'handling':
      return 'En preparación';
    case 'ready_to_ship':
      return 'Listo para enviar';
    case 'shipped':
      return 'En camino';
    case 'delivered':
      return 'Entregado';
    case 'not_delivered':
      return 'No entregado';
    case 'cancelled':
      return 'Cancelado';
    case 'to_be_agreed':
      return 'Por acordar';
    case 'lost':
      return 'Extraviado';
    case 'returned':
      return 'Devuelto';
    default:
      return status || '-';
  }
};

export const getShipmentStatusBg = (status: string) => {
  switch (status) {
    case 'handling':
      return '#FFF9E6';
    case 'ready_to_ship':
      return '#D1ECF1';
    case 'shipped':
      return '#D1ECF1';
    case 'delivered':
      return '#D6F2DF';
    case 'not_delivered':
      return '#F8D7DA';
    case 'cancelled':
      return '#F6DDDC';
    case 'to_be_agreed':
      return '#FFE5CC';
    case 'lost':
      return '#F8D7DA';
    case 'returned':
      return '#E8DAEF';
    default:
      return '#F8F9FA';
  }
};

export const getShipmentStatusColor = (status: string) => {
  switch (status) {
    case 'handling':
      return '#F39C12';
    case 'ready_to_ship':
      return '#3498DB';
    case 'shipped':
      return '#3498DB';
    case 'delivered':
      return '#27AE60';
    case 'not_delivered':
      return '#E74C3C';
    case 'cancelled':
      return '#C0392B';
    case 'to_be_agreed':
      return '#E67E22';
    case 'lost':
      return '#E74C3C';
    case 'returned':
      return '#8E44AD';
    default:
      return '#95A5A6';
  }
};

// ML statusOrder (payment statuses from Mercado Libre) — via i18n like Flex/Fulfill
export const getStatusOrderLabel = (status: string) =>
  i18n.t(`commonGeneral:status.${status}`, { defaultValue: status });

export const getStatusOrderBg = (status: string) => {
  switch (status) {
    case 'confirmed':
      return '#FFF9E6';
    case 'payment_required':
      return '#FFF3CD';
    case 'payment_in_process':
      return '#D1ECF1';
    case 'partially_paid':
      return '#FFE5CC';
    case 'paid':
      return '#D6F2DF';
    case 'partially_refunded':
      return '#E8DAEF';
    case 'pending_cancel':
      return '#F8D7DA';
    case 'cancelled':
      return '#F6DDDC';
    default:
      return '#F8F9FA';
  }
};

export const getStatusOrderColor = (status: string) => {
  switch (status) {
    case 'confirmed':
      return '#F39C12';
    case 'payment_required':
      return '#E67E22';
    case 'payment_in_process':
      return '#3498DB';
    case 'partially_paid':
      return '#E67E22';
    case 'paid':
      return '#27AE60';
    case 'partially_refunded':
      return '#8E44AD';
    case 'pending_cancel':
      return '#E74C3C';
    case 'cancelled':
      return '#C0392B';
    default:
      return '#95A5A6';
  }
};

export const statusFilters = [
  {
    width: '220px',
    filterName: 'status',
    items: [
      { value: 'confirmed' },
      { value: 'payment_required' },
      { value: 'payment_in_process' },
      { value: 'partially_paid' },
      { value: 'paid' },
      { value: 'partially_refunded' },
      { value: 'pending_cancel' },
      { value: 'cancelled' },
    ],
  },
];
